import { isPlainObject } from '~/utils/isPlainObject'

const cloneValue = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(cloneValue)

  if (isPlainObject(value)) {
    const clone: Record<string, unknown> = {}
    for (const [key, nested] of Object.entries(value)) clone[key] = cloneValue(nested)
    return clone
  }

  return value
}

/**
 * Copies a form-value record for later comparison via `findChangedFormFields`.
 * Arrays and plain objects are deep-copied so a later in-place mutation stays
 * detectable; everything else passes through by reference.
 */
export const snapshotFormValues = <TFormData extends object>(values: TFormData): TFormData =>
  cloneValue(values) as TFormData
